var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarpedChevDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0063 5.62954L13.6694 4.24975L13.594 4.30675C11.4908 5.89758 9.83302 7.38969 8.46337 9.58011L8.46337 9.58629L7.99732 10.394L7.59801 10.394L7.04836 10.394L6.56545 9.58629C5.18226 7.41105 3.55843 5.91746 1.4349 4.30684L1.35953 4.24967L0.00329239 5.64867L0.100638 5.72132C2.81113 7.74424 4.79108 9.64843 6.61957 12.6191L6.65084 12.6699L8.41774 12.6699L8.44869 12.6172C10.1239 9.76236 12.0458 7.83962 14.909 5.70218L15.0063 5.62954Z",
    fill: "#50585F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarpedChevDown);
export default __webpack_public_path__ + "static/media/warped-chev-down.f9d935a0.svg";
export { ForwardRef as ReactComponent };